import Component from '@glimmer/component';

interface GeneralTablesCellsTdChangeSignature {
  Args: {
    column?: {
      invertChangeColor?: boolean;
    };
    displayValue: string;
    value: number;
  };
}

export default class GeneralTablesCellsTdChange extends Component<GeneralTablesCellsTdChangeSignature> {
  get colorClass(): string {
    const positiveClass = this.args.column?.invertChangeColor
      ? 'text-critical-default'
      : 'text-success-default';
    const negativeClass = this.args.column?.invertChangeColor
      ? 'text-success-default'
      : 'text-critical-default';

    if (this.args.value > 0) {
      return positiveClass;
    }
    if (this.args.value < 0) {
      return negativeClass;
    }

    return '';
  }

  <template>
    <div class={{this.colorClass}}>
      {{@displayValue}}
    </div>
  </template>
}
